/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	OrganisationAiSettingsUpdatePathParams,
	OrganisationAiSettingsUpdateRequest,
	OrganisationAiSettingsUpdateResponse,
} from '../types/OrganisationAiSettingsUpdate'

/**
 * PUT /organisations/:organisation/ai-settings
 * @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationAiSettingsController.php OrganisationAiSettingsController::update
 */
export async function organisationAiSettingsUpdate(
	organisation: OrganisationAiSettingsUpdatePathParams['organisation'],
	data: OrganisationAiSettingsUpdateRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<OrganisationAiSettingsUpdateResponse>> {
	return axiosInstance.put(`/organisations/${organisation}/ai-settings`, data, config)
}
